export var LOGOUT_BUTTON_TESTID = 'logoutButton';
export var OPEN_SUPPORT_REQUEST_FORM_MENU_BUTTON_TESTID = 'openSupportRequestMenuBUtton';
